import { app } from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.directory-groups.all-accounts', {
        url: '/all-accounts',
        component: 'companyUserDirectoriesDirectoryGroupsAllAccounts',
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/directory-groups/all-accounts/all-accounts.state.js